import request from './request';

const uri = 'settings/';

const settings = {
  get: (id = '', options) => request(uri, options),
  put: (options) => request(uri, { method: 'PUT', ...options }),
};

export default settings;
